import type { Dictionary } from './en'

export const pl = {
  nav: { features: 'Funkcje', pricing: 'Cena', faq: 'Pytania', account: 'Moje konto', signIn: 'Zaloguj się' },
  hero: {
    title: 'Alt-Tab dla twojego Maca',
    tagline: 'macOS przełącza aplikacje. AppSwitch sprawia, że ⌥Tab przełącza okna — wszystkie okna, łącznie z trzema dokumentami otwartymi w tej samej aplikacji.',
    download: 'Pobierz na Maca', seePricing: 'Zobacz cenę',
    note: 'Za darmo · macOS 15 lub nowszy · Apple silicon i Intel',
    hint: 'Przytrzymaj ⌥ i naciśnij Tab — puść, aby przełączyć',
  },
  features: {
    heading: 'Dla tych, którzy trzymają dwadzieścia okien otwartych',
    sub: 'Jedno naciśnięcie ⌥Tab pokazuje je wszystkie. Puszczasz i już tam jesteś.',
    items: [
      { title: 'Każde okno, nie każda aplikacja', body: 'Przełącznik macOS przechodzi między aplikacjami. AppSwitch przechodzi między oknami — łącznie z trzema dokumentami w tej samej aplikacji.' },
      { title: 'Najpierw klawiatura', body: '⌥Tab do przodu, ⌥⇧Tab do tyłu, strzałki po siatce. Puść ⌥, a wybrane okno wysunie się na wierzch.' },
      { title: 'Nigdy nie przejmuje fokusu', body: 'Twoja aplikacja pozostaje aktywna, dopóki naprawdę nie wybierzesz. AppSwitch mieszka na pasku menu, bez ikony w Docku.' },
      { title: 'Podglądy na żywo', body: 'Zobacz prawdziwą zawartość każdego okna zamiast ogólnej ikony. Zminimalizowane okna są widoczne wprost w przełączniku.' },
    ],
  },
  pricing: {
    heading: 'Kup raz. Jest twój.',
    sub: 'Sam przełącznik jest darmowy i kompletny — to nie wersja próbna ani okrojona. Pro dodaje dwie funkcje wymagające licencji.',
    free: 'Za darmo', pro: 'Pro', ribbon: 'Zakup jednorazowy',
    freePrice: '0 €', once: 'jednorazowo',
    freeSub: 'Wszystko, by przestać używać ⌘Tab.',
    proSub: 'Bez subskrypcji. Nic się nigdy nie odnawia.',
    freeList: ['Pełny przełącznik okien pod ⌥Tab', 'Obsługa klawiaturą i myszą', 'Widok siatki i listy', 'Aplikacja paska menu, bez ikony w Docku'],
    proList: ['Wszystko z wersji darmowej', 'Podglądy na żywo każdego okna', 'Zminimalizowane okna w przełączniku', 'Dwa Maki na licencję'],
    download: 'Pobierz', buy: 'Kup AppSwitch Pro', buyBusy: 'Otwieranie płatności…',
    freeFoot: 'Bez konta. Bez karty. Bez terminu ważności.',
  },
  faq: {
    heading: 'Pytania',
    items: [
      { q: 'Dlaczego AppSwitch potrzebuje Dostępności?', a: 'To jedyny sposób, w jaki macOS pozwala aplikacji przechwycić ⌥Tab przed innymi, wyliczyć okna i wysunąć jedno na wierzch. Bez tego aplikacja w ogóle nie działa. Zgodę nadajesz sam w Ustawieniach systemowych i możesz ją cofnąć w każdej chwili.' },
      { q: 'Czy to subskrypcja?', a: 'Nie. AppSwitch Pro to zakup jednorazowy. Nic się nie odnawia, nic nie jest pobierane ponownie, a aktualizacje bieżącej wersji głównej są wliczone.' },
      { q: 'Na ilu Makach mogę używać?', a: 'Na dwóch na licencję. Miejsce możesz zwolnić w każdej chwili z konta lub z aplikacji, więc zmiana komputera nigdy nie wymaga kontaktu z pomocą.' },
      { q: 'Czy tytuły moich okien są gdzieś wysyłane?', a: 'Nie. Żadna zawartość okna, żaden tytuł ani żadne naciśnięcie klawisza nie opuszcza twojego Maca. Jedyne żądanie sieciowe to sprawdzenie licencji, i tylko jeśli kupiłeś Pro. Wersja darmowa nigdy nie korzysta z sieci.' },
      { q: 'Które wersje macOS są wspierane?', a: 'macOS 15 lub nowszy, na Apple silicon i Intel.' },
    ],
  },
  listMode: {
    heading: 'Dwa sposoby patrzenia na okna',
    sub: 'Przełączasz z paska menu albo klawiszem , gdy przełącznik jest otwarty.',
    grid: { title: 'Siatka, z podglądami', body: 'Miniatury prawdziwej zawartości. Najlepsze, gdy rozpoznajesz okno po tym, co w nim jest.' },
    list: { title: 'Lista, z pełnymi tytułami', body: 'Gęsta kolumna, w której mieści się cały tytuł każdego okna. Najlepsza przy dwudziestu terminalach albo plikach różniących się nazwą dopiero na końcu.' },
  },

  footer: { terms: 'Warunki korzystania', privacy: 'Prywatność' },
  consent: {
    text: 'Używamy Google Analytics, aby wiedzieć, które strony są przydatne. Bez twojej zgody nic nie jest mierzone. Zobacz naszą',
    privacyLink: 'politykę prywatności', accept: 'Akceptuję', decline: 'Odrzucam',
  },
} satisfies Dictionary
